import config from 'app/config';

export const hrefToDeliveryHub = (href) =>
    href.startsWith(`${config.deliveryHubURI}`)
        ? href
        : `${config.deliveryHubURI}${href}`;

export const hrefToNext = (href) =>
    href.startsWith(`${config.nextURI}`) ? href : `${config.nextURI}${href}`;
